<template>
  <div class="page-article">
    <div class="header">
      <div class="fixed_width">
        <img class="img_title"
             src="@/assets/images/article_title.jpg"
             alt="logo">
        <img class="img_date"
             v-if="article"
             src="@/assets/images/article_date01.jpg"
             alt="date">
        <!-- <span v-if="article"
              class="time">{{article.creactTime}}</span> -->
      </div>
    </div>

    <div class="content fixed_width">
      <!-- 标题 -->
      <div class="title">{{article.title}}</div>
      <!-- 副标题 -->
      <div class="label">{{article.label}}</div>
      <!-- 分割线 -->
      <div class="line"></div>
      <!-- article data start -->
      <div v-for="(item, index) in article.data"
           v-bind:key="index"
           :class="item.type">
        <!-- 段落 -->
        <template v-if="item.type === 'paragraph'">
          {{item.value}}
        </template>
        <!-- 副标题 -->
        <template v-if="item.type === 'subtitle'">
          {{item.value}}
        </template>
        <!-- 图片 -->
        <template v-if="item.type === 'image'">
          <img :src="item.url"
               alt="img">
        </template>
        <!-- 链接 -->
        <template v-if="item.type === 'link'">
          <span v-on:click="goto(item.url)">
            <i class="el-icon-link"></i>{{item.value}}
          </span>
        </template>
      </div>
      <div class="line"></div>
      <!-- 匿名提交 -->
      <div class="form">
        <div class="info">您有任何疑问、意见可以匿名提交，我们将通过专家咨询、线下访谈、专业沙龙等方式尽快回复您。</div>
        <el-input v-model="textarea"
                  type="textarea"
                  :rows="5"></el-input>
        <div class="btn">
          <el-button type="info"
                     v-on:click="submit">匿名提交</el-button>
        </div>
      </div>

      <!-- 尾部内容 -->
      <!-- <div class="footer">
        <div class="company">
          <div class="name">优与科技专注新能源汽车全生命周期管理咨询解决方案</div>
          <div class="address"
               v-on:click="goto('https://uri.amap.com/marker?position=121.43426,31.157514&name=徐锦记大厦')"><i class="el-icon-location"></i>公司地址：上海市徐汇区南宁路970号李锦记大厦901A</div>
          <div class="goto">
            <span v-on:click="goto('http://www.autobole.net/#/home')">官网入口 <i class="el-icon-d-arrow-right"></i></span>
          </div>
        </div>
        <div class="contact">
          <div class="text">针对文章内容您有什么问题可以邮件提出，我们的咨询顾问会在24小时内为您提供免费邮件咨询服务。</div>
          <div class="goto">
            <span v-on:click="goto('http://www.autobole.net/#/consulting')">咨询入口 <i class="el-icon-d-arrow-right"></i></span>
          </div>
        </div>
      </div>
      <div class="footer_mobile">
        <div class="contact">
          <div class="text">针对文章内容您有什么问题可以邮件提出，我们的咨询顾问会在24小时内为您提供免费邮件咨询服务。<span class="goto"
                  v-on:click="goto('http://www.autobole.net/#/consulting')">咨询入口 <i class="el-icon-d-arrow-right"></i></span></div>
        </div>
        <div class="company">
          <div class="name">优与科技专注新能源汽车全生命周期管理咨询解决方案</div>
          <div class="address"
               v-on:click="goto('https://uri.amap.com/marker?position=121.43426,31.157514&name=徐锦记大厦')"><i class="el-icon-location"></i>公司地址：上海市徐汇区南宁路970号李锦记大厦901A</div>
          <div class="goto">
            <span v-on:click="goto('http://www.autobole.net/#/home')">官网入口</span>
          </div>
        </div>
      </div> -->
    </div>

    <div class="fixed_width">
      <Footer />
    </div>
    <!-- <div class="beian">
      @沪ICP备案15009255号-1
    </div> -->
  </div>
</template>

<script>
import BindhtmlFontSize from '@/mixin/bindhtmlFontSize'
import articles from './articles'
import Footer from './footer/footer.vue'
import Ajax from '../../utils/ajax'

export default {
  props: {},
  components: { Footer },
  mixins: [BindhtmlFontSize],
  data() {
    return {
      article: null,
      textarea: ''
    }
  },
  beforeMount() {
    const key = this.$route.query.key
    // const key = '837430'
    const article = articles.filter(a => a.key === key)[0]
    if (!article) {
      // 404
      this.$router.push({ path: '/404' })
    } else {
      this.article = article
      // console.log('article', this.article)
    }
  },
  methods: {
    goto(url) {
      window.open(url, '_blank')
    },
    submit() {
      // const value = this.$refs['input'].value
      console.log('submit', this.textarea)
      if (this.textarea) {
        const baseUrl = 'http://backweb.autobole.net/autoboleManage/aliVin/setClick?'
        const obj = {
          content: this.textarea,
          key: this.$route.query.key || 837430
        }
        const value = baseUrl + Object.keys(obj).map(k => k + '=' + obj[k]).join('&')
        console.log('test', this.$route.query, value)
        Ajax({
          url: value,
          method: 'POST'
        }).then((res) => {
          this.request = true
          const code = res.code
          if (code === 10000) {
            this.$message({
              type: 'success',
              message: '发送成功！感谢您的反馈。'
            })
            this.resetForm()
            // console.log('完成', res)
          }
        })
        this.textarea = ''
      } else {
        this.$message.warning('内容不能为空!')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./article.scss";
@import "./footer.scss";

.page-article {
  .header {
    position: relative;
    width: 100%;
    height: 1.51rem;
    background: rgba(96, 96, 96, 1);
    // background: linear-gradient(
    //   324deg,
    //   rgba(32, 191, 242, 1) 0%,
    //   rgba(45, 223, 195, 1) 100%
    // );

    .time {
      vertical-align: middle;
      font-size: 0.19rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 0.24rem;
      margin-right: 0.2rem;
    }

    .img_title {
      height: 1.02rem;
      margin-left: 0.2rem;
    }

    .img_date {
      height: 0.86rem;
      margin-right: 0.2rem;
    }

    img {
      vertical-align: middle;
    }

    .fixed_width {
      // position: absolute;
      // top: 50%;
      // transform: translateY(-50%);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .form {
    .info {
      font-size: 0.18rem;
      font-weight: 400;
      color: rgba(88, 88, 88, 1);
      line-height: 0.32rem;
      padding-top: 0.25rem;
      padding-bottom: 0.4rem;
    }

    .btn {
      text-align: right;
      padding: 0.2rem 0.16rem;
    }
  }

  .beian {
    font-size: 0.14rem;
    font-weight: 400;
    color: rgba(203, 203, 203, 1);
    line-height: 0.2rem;
    margin-top: 0.2rem;
    margin-bottom: 0.4rem;
    text-align: center;
  }

  .fixed_width {
    height: 100%;
    max-width: 1000px;
    margin: 0 auto;
  }

  @media only screen and (max-width: 750px) {
    .beian {
      font-size: 0.2rem;
    }
  }
}
</style>
